import { ChangeDetectionStrategy, Component, HostBinding, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { select, Store } from "@ngrx/store";
import { StatusCodeService } from "@obg/ngx.core";
import {
	ContentGroupType,
	CoreContentState,
	ImageSelector,
	Quicklink,
	QuicklinkAction,
	QuicklinkSelector,
} from "@obg/ngx.core.content";
import { ignoreEmpty, StatusCodes } from "@obg/ngx.global";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

@Component({
	selector: "obg-feature-unavailable-container",
	templateUrl: "./feature-unavailable.container.html",
	styleUrls: ["./feature-unavailable.container.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	encapsulation: ViewEncapsulation.None,
})
export class FeatureUnavailableContainer implements OnInit {
	@HostBinding("class.obg-feature-unavailable") hostCssClass = true;

	backgroundImageUrl$: Observable<string | undefined> | undefined;
	quickLinks$: Observable<Quicklink[] | undefined> | undefined;

	@Input() titleText: string | undefined;
	@Input() caption: string | undefined;
	@Input() backgroundKey = "not-found.background-image";
	@Input() backgroundGroupKey: ContentGroupType = "general";
	@Input() quickLinksKey = "pageNotFoundLinks";
	@Input() statusCode: StatusCodes | undefined;
	@Input() hiddenDocumentKeys: string[] = [];

	constructor(
		private store: Store<CoreContentState>,
		private imageSelector: ImageSelector,
		private quicklinkAction: QuicklinkAction,
		private statusCodeService: StatusCodeService
	) {}

	ngOnInit() {
		this.store.dispatch(this.quicklinkAction.get());

		if (this.statusCode) {
			this.statusCodeService.setStatusCode(this.statusCode);
		}

		this.backgroundImageUrl$ = this.store.pipe(
			select(this.imageSelector.getByKey(this.backgroundGroupKey, this.backgroundKey)),
			ignoreEmpty(),
			map((img) => img.url)
		);

		this.quickLinks$ = this.store.pipe(
			select(QuicklinkSelector.get(this.quickLinksKey)),
			map((quickLinks) =>
				quickLinks.filter((quickLink) => !this.hiddenDocumentKeys.includes(quickLink.documentKey))
			)
		);
	}

	trackByQuicklink(index: number, _item: Quicklink): number {
		return index;
	}
}
